module.exports = __webpack_public_path__ + "static/media/square.7346ee01.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invitations/square.svg
// module id = 1444
// module chunks = 50